const R = {
  TEXT: "text/plain",
  JSON: "application/json",
  OCTET_STREAM: "application/octet-stream",
  // For typed arrays, we'll use application/octet-stream with a type parameter
  TYPED_ARRAY: "application/octet-stream;type=",
  // Custom MIME type for URLs that should be treated as data references
  URI: "text/x-uri"
}, h = {
  Remove: "remove",
  Replace: "replace",
  Add: "add"
}, ye = Symbol.for("__MUTATIVE_PROXY_DRAFT__"), De = Symbol("__MUTATIVE_RAW_RETURN_SYMBOL__"), K = Symbol.iterator, v = {
  mutable: "mutable",
  immutable: "immutable"
}, te = {};
function B(e, n) {
  return e instanceof Map ? e.has(n) : Object.prototype.hasOwnProperty.call(e, n);
}
function le(e, n) {
  if (n in e) {
    let t = Reflect.getPrototypeOf(e);
    for (; t; ) {
      const r = Reflect.getOwnPropertyDescriptor(t, n);
      if (r)
        return r;
      t = Reflect.getPrototypeOf(t);
    }
  }
}
function re(e) {
  return Object.getPrototypeOf(e) === Set.prototype;
}
function oe(e) {
  return Object.getPrototypeOf(e) === Map.prototype;
}
function M(e) {
  var n;
  return (n = e.copy) !== null && n !== void 0 ? n : e.original;
}
function C(e) {
  return !!u(e);
}
function u(e) {
  return typeof e != "object" ? null : e == null ? void 0 : e[ye];
}
function ie(e) {
  var n;
  const t = u(e);
  return t ? (n = t.copy) !== null && n !== void 0 ? n : t.original : e;
}
function S(e, n) {
  if (!e || typeof e != "object")
    return !1;
  let t;
  return Object.getPrototypeOf(e) === Object.prototype || Array.isArray(e) || e instanceof Map || e instanceof Set || !!(n != null && n.mark) && ((t = n.mark(e, v)) === v.immutable || typeof t == "function");
}
function we(e, n = []) {
  if (Object.hasOwnProperty.call(e, "key")) {
    const t = e.parent.copy, r = u(_(t, e.key));
    if (r !== null && (r == null ? void 0 : r.original) !== e.original)
      return null;
    const o = e.parent.type === 3, a = o ? Array.from(e.parent.setMap.keys()).indexOf(e.key) : e.key;
    if (!(o && t.size > a || B(t, a)))
      return null;
    n.push(a);
  }
  if (e.parent)
    return we(e.parent, n);
  n.reverse();
  try {
    _e(e.copy, n);
  } catch {
    return null;
  }
  return n;
}
function I(e) {
  return Array.isArray(e) ? 1 : e instanceof Map ? 2 : e instanceof Set ? 3 : 0;
}
function _(e, n) {
  return I(e) === 2 ? e.get(n) : e[n];
}
function g(e, n, t) {
  I(e) === 2 ? e.set(n, t) : e[n] = t;
}
function G(e, n) {
  const t = u(e);
  return (t ? M(t) : e)[n];
}
function D(e, n) {
  return e === n ? e !== 0 || 1 / e === 1 / n : e !== e && n !== n;
}
function Q(e) {
  if (e)
    for (; e.finalities.revoke.length > 0; )
      e.finalities.revoke.pop()();
}
function U(e, n) {
  return n ? e : [""].concat(e).map((t) => {
    const r = `${t}`;
    return r.indexOf("/") === -1 && r.indexOf("~") === -1 ? r : r.replace(/~/g, "~0").replace(/\//g, "~1");
  }).join("/");
}
function _e(e, n) {
  for (let t = 0; t < n.length - 1; t += 1) {
    const r = n[t];
    if (e = _(I(e) === 3 ? Array.from(e) : e, r), typeof e != "object")
      throw new Error(`Cannot resolve patch at '${n.join("/")}'.`);
  }
  return e;
}
function xe(e) {
  const n = Object.create(Object.getPrototypeOf(e));
  return Reflect.ownKeys(e).forEach((t) => {
    let r = Reflect.getOwnPropertyDescriptor(e, t);
    if (r.enumerable && r.configurable && r.writable) {
      n[t] = e[t];
      return;
    }
    r.writable || (r.writable = !0, r.configurable = !0), (r.get || r.set) && (r = {
      configurable: !0,
      writable: !0,
      enumerable: r.enumerable,
      value: e[t]
    }), Reflect.defineProperty(n, t, r);
  }), n;
}
const je = Object.prototype.propertyIsEnumerable;
function be(e, n) {
  let t;
  if (Array.isArray(e))
    return Array.prototype.concat.call(e);
  if (e instanceof Set) {
    if (!re(e)) {
      const r = Object.getPrototypeOf(e).constructor;
      return new r(e.values());
    }
    return Set.prototype.difference ? Set.prototype.difference.call(e, /* @__PURE__ */ new Set()) : new Set(e.values());
  } else if (e instanceof Map) {
    if (!oe(e)) {
      const r = Object.getPrototypeOf(e).constructor;
      return new r(e);
    }
    return new Map(e);
  } else if (n != null && n.mark && (t = n.mark(e, v), t !== void 0) && t !== v.mutable) {
    if (t === v.immutable)
      return xe(e);
    if (typeof t == "function") {
      if (n.enablePatches || n.enableAutoFreeze)
        throw new Error("You can't use mark and patches or auto freeze together.");
      return t();
    }
    throw new Error(`Unsupported mark result: ${t}`);
  } else if (typeof e == "object" && Object.getPrototypeOf(e) === Object.prototype) {
    const r = {};
    return Object.keys(e).forEach((o) => {
      r[o] = e[o];
    }), Object.getOwnPropertySymbols(e).forEach((o) => {
      je.call(e, o) && (r[o] = e[o]);
    }), r;
  } else
    throw new Error("Please check mark() to ensure that it is a stable marker draftable function.");
}
function b(e) {
  e.copy || (e.copy = be(e.original, e.options));
}
function N(e) {
  if (!S(e))
    return ie(e);
  if (Array.isArray(e))
    return e.map(N);
  if (e instanceof Map) {
    const t = Array.from(e.entries()).map(([r, o]) => [
      r,
      N(o)
    ]);
    if (!oe(e)) {
      const r = Object.getPrototypeOf(e).constructor;
      return new r(t);
    }
    return new Map(t);
  }
  if (e instanceof Set) {
    const t = Array.from(e).map(N);
    if (!re(e)) {
      const r = Object.getPrototypeOf(e).constructor;
      return new r(t);
    }
    return new Set(t);
  }
  const n = Object.create(Object.getPrototypeOf(e));
  for (const t in e)
    n[t] = N(e[t]);
  return n;
}
function Y(e) {
  return C(e) ? N(e) : e;
}
function T(e) {
  var n;
  e.assignedMap = (n = e.assignedMap) !== null && n !== void 0 ? n : /* @__PURE__ */ new Map(), e.operated || (e.operated = !0, e.parent && T(e.parent));
}
function ue() {
  throw new Error("Cannot modify frozen object");
}
function F(e, n, t, r, o) {
  {
    t = t ?? /* @__PURE__ */ new WeakMap(), r = r ?? [], o = o ?? [];
    const i = t.has(e) ? t.get(e) : e;
    if (r.length > 0) {
      const c = r.indexOf(i);
      if (i && typeof i == "object" && c !== -1)
        throw r[0] === i ? new Error("Forbids circular reference") : new Error(`Forbids circular reference: ~/${o.slice(0, c).map((s, f) => {
          if (typeof s == "symbol")
            return `[${s.toString()}]`;
          const l = r[f];
          return typeof s == "object" && (l instanceof Map || l instanceof Set) ? Array.from(l.keys()).indexOf(s) : s;
        }).join("/")}`);
      r.push(i), o.push(n);
    } else
      r.push(i);
  }
  if (Object.isFrozen(e) || C(e)) {
    r.pop(), o.pop();
    return;
  }
  switch (I(e)) {
    case 2:
      for (const [c, s] of e)
        F(c, c, t, r, o), F(s, c, t, r, o);
      e.set = e.clear = e.delete = ue;
      break;
    case 3:
      for (const c of e)
        F(c, c, t, r, o);
      e.add = e.clear = e.delete = ue;
      break;
    case 1:
      Object.freeze(e);
      let i = 0;
      for (const c of e)
        F(c, i, t, r, o), i += 1;
      break;
    default:
      Object.freeze(e), Object.keys(e).forEach((c) => {
        const s = e[c];
        F(s, c, t, r, o);
      });
  }
  r.pop(), o.pop();
}
function se(e, n) {
  const t = I(e);
  if (t === 0)
    Reflect.ownKeys(e).forEach((r) => {
      n(r, e[r], e);
    });
  else if (t === 1) {
    let r = 0;
    for (const o of e)
      n(r, o, e), r += 1;
  } else
    e.forEach((r, o) => n(o, r, e));
}
function me(e, n, t) {
  if (C(e) || !S(e, t) || n.has(e) || Object.isFrozen(e))
    return;
  const r = e instanceof Set, o = r ? /* @__PURE__ */ new Map() : void 0;
  if (n.add(e), se(e, (a, i) => {
    var c;
    if (C(i)) {
      const s = u(i);
      b(s);
      const f = !((c = s.assignedMap) === null || c === void 0) && c.size || s.operated ? s.copy : s.original;
      g(r ? o : e, a, f);
    } else
      me(i, n, t);
  }), o) {
    const a = e, i = Array.from(a);
    a.clear(), i.forEach((c) => {
      a.add(o.has(c) ? o.get(c) : c);
    });
  }
}
function Ce(e, n) {
  const t = e.type === 3 ? e.setMap : e.copy;
  e.finalities.revoke.length > 1 && e.assignedMap.get(n) && t && me(_(t, n), e.finalities.handledSet, e.options);
}
function Z(e) {
  e.type === 3 && e.copy && (e.copy.clear(), e.setMap.forEach((n) => {
    e.copy.add(ie(n));
  }));
}
function k(e, n, t, r) {
  if (e.operated && e.assignedMap && e.assignedMap.size > 0 && !e.finalized) {
    if (t && r) {
      const a = we(e);
      a && n(e, a, t, r);
    }
    e.finalized = !0;
  }
}
function ce(e, n, t, r) {
  const o = u(t);
  o && (o.callbacks || (o.callbacks = []), o.callbacks.push((a, i) => {
    var c;
    const s = e.type === 3 ? e.setMap : e.copy;
    if (D(_(s, n), t)) {
      let f = o.original;
      o.copy && (f = o.copy), Z(e), k(e, r, a, i), e.options.enableAutoFreeze && (e.options.updatedValues = (c = e.options.updatedValues) !== null && c !== void 0 ? c : /* @__PURE__ */ new WeakMap(), e.options.updatedValues.set(f, o.original)), g(s, n, f);
    }
  }), e.options.enableAutoFreeze && o.finalities !== e.finalities && (e.options.enableAutoFreeze = !1)), S(t, e.options) && e.finalities.draft.push(() => {
    const a = e.type === 3 ? e.setMap : e.copy;
    D(_(a, n), t) && Ce(e, n);
  });
}
function Ue(e, n, t, r, o) {
  let { original: a, assignedMap: i, options: c } = e, s = e.copy;
  s.length < a.length && ([a, s] = [s, a], [t, r] = [r, t]);
  for (let f = 0; f < a.length; f += 1)
    if (i.get(f.toString()) && s[f] !== a[f]) {
      const l = n.concat([f]), p = U(l, o);
      t.push({
        op: h.Replace,
        path: p,
        // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
        value: Y(s[f])
      }), r.push({
        op: h.Replace,
        path: p,
        // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
        value: Y(a[f])
      });
    }
  for (let f = a.length; f < s.length; f += 1) {
    const l = n.concat([f]), p = U(l, o);
    t.push({
      op: h.Add,
      path: p,
      // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
      value: Y(s[f])
    });
  }
  if (a.length < s.length) {
    const { arrayLengthAssignment: f = !0 } = c.enablePatches;
    if (f) {
      const l = n.concat(["length"]), p = U(l, o);
      r.push({
        op: h.Replace,
        path: p,
        value: a.length
      });
    } else
      for (let l = s.length; a.length < l; l -= 1) {
        const p = n.concat([l - 1]), y = U(p, o);
        r.push({
          op: h.Remove,
          path: y
        });
      }
  }
}
function Ie({ original: e, copy: n, assignedMap: t }, r, o, a, i) {
  t.forEach((c, s) => {
    const f = _(e, s), l = Y(_(n, s)), p = c ? B(e, s) ? h.Replace : h.Add : h.Remove;
    if (D(f, l) && p === h.Replace)
      return;
    const y = r.concat(s), w = U(y, i);
    o.push(p === h.Remove ? { op: p, path: w } : { op: p, path: w, value: l }), a.push(p === h.Add ? { op: h.Remove, path: w } : p === h.Remove ? { op: h.Add, path: w, value: f } : { op: h.Replace, path: w, value: f });
  });
}
function Fe({ original: e, copy: n }, t, r, o, a) {
  let i = 0;
  e.forEach((c) => {
    if (!n.has(c)) {
      const s = t.concat([i]), f = U(s, a);
      r.push({
        op: h.Remove,
        path: f,
        value: c
      }), o.unshift({
        op: h.Add,
        path: f,
        value: c
      });
    }
    i += 1;
  }), i = 0, n.forEach((c) => {
    if (!e.has(c)) {
      const s = t.concat([i]), f = U(s, a);
      r.push({
        op: h.Add,
        path: f,
        value: c
      }), o.unshift({
        op: h.Remove,
        path: f,
        value: c
      });
    }
    i += 1;
  });
}
function V(e, n, t, r) {
  const { pathAsArray: o = !0 } = e.options.enablePatches;
  switch (e.type) {
    case 0:
    case 2:
      return Ie(e, n, t, r, o);
    case 1:
      return Ue(e, n, t, r, o);
    case 3:
      return Fe(e, n, t, r, o);
  }
}
let $e = !1;
const W = (e, n, t = !1) => {
  if (typeof e == "object" && e !== null && (!S(e, n) || t) && !$e)
    throw new Error("Strict mode: Mutable data cannot be accessed directly, please use 'unsafe(callback)' wrap.");
}, ee = {
  get size() {
    return M(u(this)).size;
  },
  has(e) {
    return M(u(this)).has(e);
  },
  set(e, n) {
    const t = u(this), r = M(t);
    return (!r.has(e) || !D(r.get(e), n)) && (b(t), T(t), t.assignedMap.set(e, !0), t.copy.set(e, n), ce(t, e, n, V)), this;
  },
  delete(e) {
    if (!this.has(e))
      return !1;
    const n = u(this);
    return b(n), T(n), n.original.has(e) ? n.assignedMap.set(e, !1) : n.assignedMap.delete(e), n.copy.delete(e), !0;
  },
  clear() {
    const e = u(this);
    if (this.size) {
      b(e), T(e), e.assignedMap = /* @__PURE__ */ new Map();
      for (const [n] of e.original)
        e.assignedMap.set(n, !1);
      e.copy.clear();
    }
  },
  forEach(e, n) {
    const t = u(this);
    M(t).forEach((r, o) => {
      e.call(n, this.get(o), o, this);
    });
  },
  get(e) {
    var n, t;
    const r = u(this), o = M(r).get(e), a = ((t = (n = r.options).mark) === null || t === void 0 ? void 0 : t.call(n, o, v)) === v.mutable;
    if (r.options.strict && W(o, r.options, a), a || r.finalized || !S(o, r.options) || o !== r.original.get(e))
      return o;
    const i = te.createDraft({
      original: o,
      parentDraft: r,
      key: e,
      finalities: r.finalities,
      options: r.options
    });
    return b(r), r.copy.set(e, i), i;
  },
  keys() {
    return M(u(this)).keys();
  },
  values() {
    const e = this.keys();
    return {
      [K]: () => this.values(),
      next: () => {
        const n = e.next();
        return n.done ? n : {
          done: !1,
          value: this.get(n.value)
        };
      }
    };
  },
  entries() {
    const e = this.keys();
    return {
      [K]: () => this.entries(),
      next: () => {
        const n = e.next();
        if (n.done)
          return n;
        const t = this.get(n.value);
        return {
          done: !1,
          value: [n.value, t]
        };
      }
    };
  },
  [K]() {
    return this.entries();
  }
}, Ne = Reflect.ownKeys(ee), pe = (e, n, { isValuesIterator: t }) => () => {
  var r, o;
  const a = n.next();
  if (a.done)
    return a;
  const i = a.value;
  let c = e.setMap.get(i);
  const s = u(c), f = ((o = (r = e.options).mark) === null || o === void 0 ? void 0 : o.call(r, c, v)) === v.mutable;
  if (e.options.strict && W(i, e.options, f), !f && !s && S(i, e.options) && !e.finalized && e.original.has(i)) {
    const l = te.createDraft({
      original: i,
      parentDraft: e,
      key: i,
      finalities: e.finalities,
      options: e.options
    });
    e.setMap.set(i, l), c = l;
  } else s && (c = s.proxy);
  return {
    done: !1,
    value: t ? c : [c, c]
  };
}, J = {
  get size() {
    return u(this).setMap.size;
  },
  has(e) {
    const n = u(this);
    if (n.setMap.has(e))
      return !0;
    b(n);
    const t = u(e);
    return !!(t && n.setMap.has(t.original));
  },
  add(e) {
    const n = u(this);
    return this.has(e) || (b(n), T(n), n.assignedMap.set(e, !0), n.setMap.set(e, e), ce(n, e, e, V)), this;
  },
  delete(e) {
    if (!this.has(e))
      return !1;
    const n = u(this);
    b(n), T(n);
    const t = u(e);
    return t && n.setMap.has(t.original) ? (n.assignedMap.set(t.original, !1), n.setMap.delete(t.original)) : (!t && n.setMap.has(e) ? n.assignedMap.set(e, !1) : n.assignedMap.delete(e), n.setMap.delete(e));
  },
  clear() {
    if (!this.size)
      return;
    const e = u(this);
    b(e), T(e);
    for (const n of e.original)
      e.assignedMap.set(n, !1);
    e.setMap.clear();
  },
  values() {
    const e = u(this);
    b(e);
    const n = e.setMap.keys();
    return {
      [Symbol.iterator]: () => this.values(),
      next: pe(e, n, { isValuesIterator: !0 })
    };
  },
  entries() {
    const e = u(this);
    b(e);
    const n = e.setMap.keys();
    return {
      [Symbol.iterator]: () => this.entries(),
      next: pe(e, n, {
        isValuesIterator: !1
      })
    };
  },
  keys() {
    return this.values();
  },
  [K]() {
    return this.values();
  },
  forEach(e, n) {
    const t = this.values();
    let r = t.next();
    for (; !r.done; )
      e.call(n, r.value, r.value, this), r = t.next();
  }
};
Set.prototype.difference && Object.assign(J, {
  intersection(e) {
    return Set.prototype.intersection.call(new Set(this.values()), e);
  },
  union(e) {
    return Set.prototype.union.call(new Set(this.values()), e);
  },
  difference(e) {
    return Set.prototype.difference.call(new Set(this.values()), e);
  },
  symmetricDifference(e) {
    return Set.prototype.symmetricDifference.call(new Set(this.values()), e);
  },
  isSubsetOf(e) {
    return Set.prototype.isSubsetOf.call(new Set(this.values()), e);
  },
  isSupersetOf(e) {
    return Set.prototype.isSupersetOf.call(new Set(this.values()), e);
  },
  isDisjointFrom(e) {
    return Set.prototype.isDisjointFrom.call(new Set(this.values()), e);
  }
});
const Be = Reflect.ownKeys(J), Oe = {
  get(e, n, t) {
    var r, o;
    const a = (r = e.copy) === null || r === void 0 ? void 0 : r[n];
    if (a && e.finalities.draftsCache.has(a))
      return a;
    if (n === ye)
      return e;
    let i;
    if (e.options.mark) {
      const f = n === "size" && (e.original instanceof Map || e.original instanceof Set) ? Reflect.get(e.original, n) : Reflect.get(e.original, n, t);
      if (i = e.options.mark(f, v), i === v.mutable)
        return e.options.strict && W(f, e.options, !0), f;
    }
    const c = M(e);
    if (c instanceof Map && Ne.includes(n))
      return n === "size" ? Object.getOwnPropertyDescriptor(ee, "size").get.call(e.proxy) : ee[n].bind(e.proxy);
    if (c instanceof Set && Be.includes(n))
      return n === "size" ? Object.getOwnPropertyDescriptor(J, "size").get.call(e.proxy) : J[n].bind(e.proxy);
    if (!B(c, n)) {
      const f = le(c, n);
      return f ? "value" in f ? f.value : (
        // !case: support for getter
        (o = f.get) === null || o === void 0 ? void 0 : o.call(e.proxy)
      ) : void 0;
    }
    const s = c[n];
    if (e.options.strict && W(s, e.options), e.finalized || !S(s, e.options))
      return s;
    if (s === G(e.original, n)) {
      if (b(e), e.copy[n] = ae({
        original: e.original[n],
        parentDraft: e,
        key: e.type === 1 ? Number(n) : n,
        finalities: e.finalities,
        options: e.options
      }), typeof i == "function") {
        const f = u(e.copy[n]);
        return b(f), T(f), f.copy;
      }
      return e.copy[n];
    }
    return C(s) && e.finalities.draftsCache.add(s), s;
  },
  set(e, n, t) {
    var r;
    if (e.type === 3 || e.type === 2)
      throw new Error("Map/Set draft does not support any property assignment.");
    let o;
    if (e.type === 1 && n !== "length" && !(Number.isInteger(o = Number(n)) && o >= 0 && (n === 0 || o === 0 || String(o) === String(n))))
      throw new Error("Only supports setting array indices and the 'length' property.");
    const a = le(M(e), n);
    if (a != null && a.set)
      return a.set.call(e.proxy, t), !0;
    const i = G(M(e), n), c = u(i);
    return c && D(c.original, t) ? (e.copy[n] = t, e.assignedMap = (r = e.assignedMap) !== null && r !== void 0 ? r : /* @__PURE__ */ new Map(), e.assignedMap.set(n, !1), !0) : (D(t, i) && (t !== void 0 || B(e.original, n)) || (b(e), T(e), B(e.original, n) && D(t, e.original[n]) ? e.assignedMap.delete(n) : e.assignedMap.set(n, !0), e.copy[n] = t, ce(e, n, t, V)), !0);
  },
  has(e, n) {
    return n in M(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(M(e));
  },
  getOwnPropertyDescriptor(e, n) {
    const t = M(e), r = Reflect.getOwnPropertyDescriptor(t, n);
    return r && {
      writable: !0,
      configurable: e.type !== 1 || n !== "length",
      enumerable: r.enumerable,
      value: t[n]
    };
  },
  getPrototypeOf(e) {
    return Reflect.getPrototypeOf(e.original);
  },
  setPrototypeOf() {
    throw new Error("Cannot call 'setPrototypeOf()' on drafts");
  },
  defineProperty() {
    throw new Error("Cannot call 'defineProperty()' on drafts");
  },
  deleteProperty(e, n) {
    var t;
    return e.type === 1 ? Oe.set.call(this, e, n, void 0, e.proxy) : (G(e.original, n) !== void 0 || n in e.original ? (b(e), T(e), e.assignedMap.set(n, !1)) : (e.assignedMap = (t = e.assignedMap) !== null && t !== void 0 ? t : /* @__PURE__ */ new Map(), e.assignedMap.delete(n)), e.copy && delete e.copy[n], !0);
  }
};
function ae(e) {
  const { original: n, parentDraft: t, key: r, finalities: o, options: a } = e, i = I(n), c = {
    type: i,
    finalized: !1,
    parent: t,
    original: n,
    copy: null,
    proxy: null,
    finalities: o,
    options: a,
    // Mapping of draft Set items to their corresponding draft values.
    setMap: i === 3 ? new Map(n.entries()) : void 0
  };
  (r || "key" in e) && (c.key = r);
  const { proxy: s, revoke: f } = Proxy.revocable(i === 1 ? Object.assign([], c) : c, Oe);
  if (o.revoke.push(f), c.proxy = s, t) {
    const l = t;
    l.finalities.draft.push((p, y) => {
      var w, z;
      const x = u(s);
      let E = l.type === 3 ? l.setMap : l.copy;
      const m = _(E, r), O = u(m);
      if (O) {
        let A = O.original;
        O.operated && (A = ie(m)), Z(O), k(O, V, p, y), l.options.enableAutoFreeze && (l.options.updatedValues = (w = l.options.updatedValues) !== null && w !== void 0 ? w : /* @__PURE__ */ new WeakMap(), l.options.updatedValues.set(A, O.original)), g(E, r, A);
      }
      (z = x.callbacks) === null || z === void 0 || z.forEach((A) => {
        A(p, y);
      });
    });
  } else {
    const l = u(s);
    l.finalities.draft.push((p, y) => {
      Z(l), k(l, V, p, y);
    });
  }
  return s;
}
te.createDraft = ae;
function Ve(e, n, t, r, o) {
  var a;
  const i = u(e), c = (a = i == null ? void 0 : i.original) !== null && a !== void 0 ? a : e, s = !!n.length;
  if (i != null && i.operated)
    for (; i.finalities.draft.length > 0; )
      i.finalities.draft.pop()(t, r);
  const f = s ? n[0] : i ? i.operated ? i.copy : i.original : e;
  return i && Q(i), o && F(f, f, i == null ? void 0 : i.options.updatedValues), [
    f,
    t && s ? [{ op: h.Replace, path: [], value: n[0] }] : t,
    r && s ? [{ op: h.Replace, path: [], value: c }] : r
  ];
}
function ge(e, n) {
  var t;
  const r = {
    draft: [],
    revoke: [],
    handledSet: /* @__PURE__ */ new WeakSet(),
    draftsCache: /* @__PURE__ */ new WeakSet()
  };
  let o, a;
  n.enablePatches && (o = [], a = []);
  const c = ((t = n.mark) === null || t === void 0 ? void 0 : t.call(n, e, v)) === v.mutable || !S(e, n) ? e : ae({
    original: e,
    parentDraft: null,
    finalities: r,
    options: n
  });
  return [
    c,
    (s = []) => {
      const [f, l, p] = Ve(c, s, o, a, n.enableAutoFreeze);
      return n.enablePatches ? [f, l, p] : f;
    }
  ];
}
function ne(e) {
  const { rootDraft: n, value: t, useRawReturn: r = !1, isRoot: o = !0 } = e;
  se(t, (a, i, c) => {
    const s = u(i);
    if (s && n && s.finalities === n.finalities) {
      e.isContainDraft = !0;
      const f = s.original;
      if (c instanceof Set) {
        const l = Array.from(c);
        c.clear(), l.forEach((p) => c.add(a === p ? f : p));
      } else
        g(c, a, f);
    } else typeof i == "object" && i !== null && (e.value = i, e.isRoot = !1, ne(e));
  }), o && (e.isContainDraft || console.warn("The return value does not contain any draft, please use 'rawReturn()' to wrap the return value to improve performance."), r && console.warn("The return value contains drafts, please don't use 'rawReturn()' to wrap the return value."));
}
function Me(e) {
  var n;
  const t = u(e);
  if (!S(e, t == null ? void 0 : t.options))
    return e;
  const r = I(e);
  if (t && !t.operated)
    return t.original;
  let o;
  function a() {
    o = r === 2 ? oe(e) ? new Map(e) : new (Object.getPrototypeOf(e)).constructor(e) : r === 3 ? Array.from(t.setMap.values()) : be(e, t == null ? void 0 : t.options);
  }
  if (t) {
    t.finalized = !0;
    try {
      a();
    } finally {
      t.finalized = !1;
    }
  } else
    o = e;
  if (se(o, (i, c) => {
    if (t && D(_(t.original, i), c))
      return;
    const s = Me(c);
    s !== c && (o === e && a(), g(o, i, s));
  }), r === 3) {
    const i = (n = t == null ? void 0 : t.original) !== null && n !== void 0 ? n : o;
    return re(i) ? new Set(o) : new (Object.getPrototypeOf(i)).constructor(o);
  }
  return o;
}
function de(e) {
  if (!C(e))
    throw new Error(`current() is only used for Draft, parameter: ${e}`);
  return Me(e);
}
const Le = (e) => function n(t, r, o) {
  var a, i, c;
  if (typeof t == "function" && typeof r != "function")
    return function(d, ...P) {
      return n(d, (j) => t.call(this, j, ...P), r);
    };
  const s = t, f = r;
  let l = o;
  if (typeof r != "function" && (l = r), l !== void 0 && Object.prototype.toString.call(l) !== "[object Object]")
    throw new Error(`Invalid options: ${l}, 'options' should be an object.`);
  l = Object.assign(Object.assign({}, e), l);
  const p = C(s) ? de(s) : s, y = Array.isArray(l.mark) ? (d, P) => {
    for (const j of l.mark) {
      if (typeof j != "function")
        throw new Error(`Invalid mark: ${j}, 'mark' should be a function.`);
      const $ = j(d, P);
      if ($)
        return $;
    }
  } : l.mark, w = (a = l.enablePatches) !== null && a !== void 0 ? a : !1, z = (i = l.strict) !== null && i !== void 0 ? i : !1, E = {
    enableAutoFreeze: (c = l.enableAutoFreeze) !== null && c !== void 0 ? c : !1,
    mark: y,
    strict: z,
    enablePatches: w
  };
  if (!S(p, E) && typeof p == "object" && p !== null)
    throw new Error("Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.");
  const [m, O] = ge(p, E);
  if (typeof r != "function") {
    if (!S(p, E))
      throw new Error("Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.");
    return [m, O];
  }
  let A;
  try {
    A = f(m);
  } catch (d) {
    throw Q(u(m)), d;
  }
  const fe = (d) => {
    const P = u(m);
    if (!C(d)) {
      if (d !== void 0 && !D(d, m) && (P != null && P.operated))
        throw new Error("Either the value is returned as a new non-draft value, or only the draft is modified without returning any value.");
      const $ = d == null ? void 0 : d[De];
      if ($) {
        const Pe = $[0];
        return E.strict && typeof d == "object" && d !== null && ne({
          rootDraft: P,
          value: d,
          useRawReturn: !0
        }), O([Pe]);
      }
      if (d !== void 0)
        return typeof d == "object" && d !== null && ne({ rootDraft: P, value: d }), O([d]);
    }
    if (d === m || d === void 0)
      return O([]);
    const j = u(d);
    if (E === j.options) {
      if (j.operated)
        throw new Error("Cannot return a modified child draft.");
      return O([de(d)]);
    }
    return O([d]);
  };
  return A instanceof Promise ? A.then(fe, (d) => {
    throw Q(u(m)), d;
  }) : fe(A);
}, ve = Le();
Object.prototype.constructor.toString();
const Re = (e) => typeof e == "string" && e.startsWith("data:"), X = (e) => {
  const n = e.match(/^data:([^;]+)/);
  return n ? n[1] : R.OCTET_STREAM;
}, Se = (e) => {
  var r;
  const n = {}, t = (r = e.match(/^data:[^;]+;([^,]+),/)) == null ? void 0 : r[1];
  return t && t.split(";").forEach((o) => {
    const [a, i] = o.split("=");
    a && i && (n[a] = i);
  }), n;
}, Ge = (e) => {
  const n = encodeURIComponent(e);
  return `data:${R.TEXT};charset=utf-8,${n}`;
}, Qe = (e) => {
  const n = JSON.stringify(e), t = encodeURIComponent(n);
  return `data:${R.JSON};charset=utf-8,${t}`;
}, Ee = (e) => {
  const n = new Uint8Array(e), t = btoa(String.fromCharCode(...n));
  return `data:${R.OCTET_STREAM};base64,${t}`;
}, Ze = (e, n) => {
  const t = e.buffer, r = new Uint8Array(t), o = btoa(String.fromCharCode(...r));
  return `data:${R.TYPED_ARRAY}${n};base64,${o}`;
}, q = async (e, n) => {
  if (We(e)) {
    const i = ze(e);
    if (!i)
      throw new Error("Invalid URL data URL");
    const c = await fetch(i, { ...n, redirect: "follow" });
    if (!c.ok)
      throw new Error(`Failed to fetch ${i}: ${c.statusText}`);
    return c.arrayBuffer();
  }
  const t = e.indexOf(",");
  if (t === -1)
    throw new Error("Invalid data URL format");
  const r = e.substring(0, t), o = e.substring(t + 1);
  if (r.includes(";base64")) {
    if (!o)
      return new ArrayBuffer(0);
    const i = atob(o), c = new Uint8Array(i.length);
    for (let s = 0; s < i.length; s++)
      c[s] = i.charCodeAt(s);
    return c.buffer;
  } else {
    const i = o ? decodeURIComponent(o) : "";
    return new TextEncoder().encode(i).buffer;
  }
}, Ae = async (e, n) => {
  const t = await q(e, n);
  return new TextDecoder().decode(t);
}, Ke = async (e, n) => {
  const t = await Ae(e, n);
  return JSON.parse(t);
}, Ye = async (e, n) => {
  const r = Se(e).type;
  if (!r)
    throw new Error("Data URL does not contain type parameter");
  const o = await q(e, n), a = globalThis[r];
  return new a(o);
}, ke = async (e, n, t) => {
  const r = X(e), o = await q(e, t);
  if (!n) {
    const a = await crypto.subtle.digest("SHA-256", o);
    n = Array.from(new Uint8Array(a)).map((c) => c.toString(16).padStart(2, "0")).join("");
  }
  return new File([o], n, { type: r });
}, Te = async (e, n) => {
  const t = `data:${R.URI};charset=utf-8,${encodeURIComponent(e)}`;
  if (n) {
    const r = await fetch(e, { ...n, redirect: "follow" });
    if (!r.ok)
      throw new Error(`Failed to fetch ${e}: ${r.statusText}`);
    const o = await r.arrayBuffer();
    return Ee(o);
  }
  return t;
}, ze = (e) => X(e) !== R.URI ? null : decodeURIComponent(e.split(",")[1]), We = (e) => X(e) === R.URI, en = async (e, n) => {
  if (typeof e == "string")
    return Te(e, n);
  const t = await e.arrayBuffer();
  return Ee(t);
}, nn = async (e, n) => {
  const t = ze(e);
  if (!t)
    throw new Error("Data URL does not contain a URL reference");
  return Te(t, n);
}, tn = async (e, n, t) => {
  const r = [], o = (s) => new TextEncoder().encode(JSON.stringify(s)).length, a = (s) => s === null ? "null" : Array.isArray(s) ? "array" : s instanceof Uint8Array ? "Uint8Array" : s instanceof ArrayBuffer ? "ArrayBuffer" : ArrayBuffer.isView(s) ? s.constructor.name : typeof s, i = (s, f = []) => {
    if (s == null || typeof s != "object" || typeof s == "string" && Re(s))
      return;
    if (o(s) > n && f.length > 0) {
      const y = a(s), w = JSON.stringify(s), z = t(w, y).then((x) => ({
        url: x,
        originalType: y
      }));
      r.push({ path: [...f], promise: z });
      return;
    }
    Array.isArray(s) ? s.forEach((y, w) => {
      i(y, [...f, w]);
    }) : Object.keys(s).forEach((y) => {
      i(s[y], [...f, y]);
    });
  };
  if (i(e), r.length === 0)
    return e;
  const c = await Promise.all(r.map((s) => s.promise));
  return ve(e, (s) => {
    r.forEach(({ path: f }, l) => {
      const { url: p, originalType: y } = c[l], w = encodeURIComponent(p), z = `data:${R.URI};type=${y};charset=utf-8,${w}`;
      let x = s;
      for (let m = 0; m < f.length - 1; m++)
        x = x[f[m]];
      const E = f[f.length - 1];
      x[E] = z;
    });
  });
}, rn = async (e, n) => {
  const t = [], r = (a, i = []) => {
    if (a != null)
      if (typeof a == "string" && Re(a)) {
        const c = Je(a, n);
        t.push({ path: [...i], promise: c });
      } else Array.isArray(a) ? a.forEach((c, s) => {
        r(c, [...i, s]);
      }) : typeof a == "object" && Object.keys(a).forEach((c) => {
        r(a[c], [...i, c]);
      });
  };
  if (r(e), t.length === 0)
    return e;
  const o = await Promise.all(t.map((a) => a.promise));
  return ve(e, (a) => {
    t.forEach(({ path: i }, c) => {
      let s = a;
      for (let l = 0; l < i.length - 1; l++)
        s = s[i[l]];
      const f = i[i.length - 1];
      s[f] = o[c];
    });
  });
}, Je = async (e, n) => {
  const t = X(e), r = Se(e);
  return t === R.JSON ? Ke(e, n) : t === R.TEXT ? Ae(e, n) : t === R.OCTET_STREAM && r.type ? Ye(e, n) : q(e, n);
};
var he = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", He = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var L = 0; L < he.length; L++)
  He[he.charCodeAt(L)] = L;
var H;
(function(e) {
  e.base64 = "base64", e.url = "url", e.utf8 = "utf8", e.json = "json", e.key = "key";
})(H || (H = {}));
const Xe = Object.keys(H).filter((e) => isNaN(Number(e)));
new Set(Xe);
H.utf8;
const qe = (e) => !!(e && typeof e == "object" && // until we get this in:
// https://github.com/metapages/dataref/issues/1
// then we fail on previous versions that assumed type
// was "url" if missing, ugh.
// (value as DataRef)?.type &&
// DataRefTypesSet.has((value as DataRef).type!) &&
(e == null ? void 0 : e.value) !== void 0);
new TextEncoder();
const on = (e) => !!(e && typeof e == "string" && e.startsWith("data:")) || qe(e);
export {
  R as MIME_TYPES,
  Ee as bufferToDataUrl,
  tn as convertLargeObjectsToDataRefs,
  q as dataUrlToBuffer,
  ke as dataUrlToFile,
  Ke as dataUrlToJson,
  Ae as dataUrlToText,
  Ye as dataUrlToTypedArray,
  ze as dataUrlToUrl,
  rn as dereferenceDataRefs,
  nn as fetchDataUrlContent,
  en as fileToDataUrl,
  X as getMimeType,
  Se as getParameters,
  on as isDataRef,
  Re as isDataUrl,
  We as isUrlDataUrl,
  Qe as jsonToDataUrl,
  Ge as textToDataUrl,
  Ze as typedArrayToDataUrl,
  Te as urlToDataUrl
};
//# sourceMappingURL=index.js.map
